// @flow @jsx h
import { h, Component } from 'preact'
import styles from './App.css'
import Menu from './Menu'
import type { MenuItemType } from './types'

type Props = {
  menuItems: Array<MenuItemType>,
  contextId: string
}

export class App extends Component<Props> {
  render () {
    const { menuItems, contextId } = this.props
    return (
      <div class={styles.app}>
        <Menu menuItems={menuItems} contextId={contextId} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/App.js